import { useViewport } from "../../../../hooks/useViewport";
import { TableFooterClock } from "./TableFooterClock";

interface TableRailProps {
  /** Скрита релса — на тесен екран след двоен клик върху маса. */
  hidden: boolean;
  children: React.ReactNode;
}

/**
 * Релсата с маси вляво: списъкът (скролва се сам в `TableList`) и под него
 * часовникът — само на десктоп. Часовникът е тук, а не в лентата под масите,
 * за да остане цялата лента за бутоните (и за изнесените от „Опции").
 * Височината на реда съвпада с реда на „Обобщено" вдясно (`OrderDetails`).
 */
export const TableRail = ({ hidden, children }: TableRailProps) => {
  const { isDesktop } = useViewport();
  return (
    <aside
      className={`w-[124px] sm:w-44 lg:w-[clamp(340px,26%,470px)] flex flex-col flex-shrink-0 bg-pos-panel border-r border-pos-line ${
        hidden ? "hidden" : ""
      }`}
    >
      <div className="flex-1 min-h-0 overflow-y-auto">{children}</div>
      {isDesktop && (
        <div className="shrink-0 flex h-12 items-center px-5">
          <TableFooterClock />
        </div>
      )}
    </aside>
  );
};
